import { render, staticRenderFns } from "./costcalc.vue?vue&type=template&id=4061d90c&scoped=true&"
import script from "./costcalc.vue?vue&type=script&lang=js&"
export * from "./costcalc.vue?vue&type=script&lang=js&"
import style0 from "./costcalc.vue?vue&type=style&index=0&id=4061d90c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4061d90c",
  null
  
)

export default component.exports